import { Button } from '@shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-light-svg-icons';

interface MobileActionsMenuProps {
  onOpenInternalCatalog: () => void;
  onOpenCourierCatalog: () => void;
  onOpenCreateMapping: () => void;
}

export const MobileActionsMenu = ({
  onOpenInternalCatalog,
  onOpenCourierCatalog,
  onOpenCreateMapping,
}: MobileActionsMenuProps) => {
  const { t } = useTranslation('mappingsModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="w-10 h-10">
          <FontAwesomeIcon icon={faEllipsisV} className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem onSelect={onOpenInternalCatalog}>{t('shortcuts.view_internal_catalog')}</DropdownMenuItem>
        <DropdownMenuItem onSelect={onOpenCourierCatalog}>{t('shortcuts.view_courier_catalog')}</DropdownMenuItem>
        <DropdownMenuItem
          onSelect={onOpenCreateMapping}
          className="bg-primary text-white hover:bg-primary hover:text-white"
        >
          {t('create_button')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
